import Alpine from "alpinejs";

Alpine.data("video", (autoplay = false) => ({
    playing: autoplay,
    init() {
        this.$nextTick(() => {
            this.$refs.video?.addEventListener("play", () => {
                this.playing = true;
            });
            this.$refs.video?.addEventListener("pause", () => {
                this.playing = false;
            });
        });
    },
    toggle() {
        if (this.$refs.video) {
            if (this.$refs.video.paused) {
                this.$refs.video?.play();
            } else {
                this.$refs.video?.pause();
            }
        } else {
            this.playing = !this.playing;
        }
    },
}));
